import { alertsAtom } from '@/store';
import Close from '../Icons/Close';
import HazardIcon from '../Icons/HazardIcon';
import { useAtom } from 'jotai';
import CheckCircleIcon from '../Icons/CheckCircleIcon';
import WarningIcon from '../Icons/WarningIcon';
import InfoIcon from '../Icons/InfoIcon';

type AlertProps = {
  message: string;
  subMessage?: string;
  alertId: string;
  type: 'success' | 'info' | 'warning' | 'error';
};

const BaseAlert = ({ message, subMessage, alertId, type }: AlertProps) => {
  const [alerts, setAlerts] = useAtom(alertsAtom);

  const close = () => {
    delete alerts[alertId];
    setAlerts({ ...alerts });
  };

  const getIcon = () => {
    if (type === 'success') {
      return <CheckCircleIcon />;
    }
    if (type === 'info') {
      return <InfoIcon />;
    }
    if (type === 'warning') {
      return <WarningIcon />;
    }
    return <HazardIcon />;
  };

  return (
    <div className="relative">
      <div
        className="absolute -right-12 -top-[14px] cursor-pointer rounded-full border-1 border-white-5 bg-white-100 p-[6px] text-neutral-10"
        onClick={close}
      >
        <Close height="16" width="16" />
      </div>
      <div
        className={`flex w-[460px] max-w-[80vw] gap-16 rounded-28 bg-state-${type}-background items-center p-16 shadow-sm`}
      >
        <span className={`text-state-${type}`}>{getIcon()}</span>
        <div className="flex flex-col">
          <span className="font-medium">{message}</span>
          {subMessage && <span>{subMessage}</span>}
        </div>
      </div>
    </div>
  );
};

export default BaseAlert;
